module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "content nc-page"
  }, [(_vm.campaignId && _vm.detail) ? _c('campaign-analytics', {
    attrs: {
      "campaign": _vm.detail.campaign,
      "totals": _vm.detail.totals,
      "variants": _vm.detail.variants,
      "daily": _vm.detail.daily,
      "funnel": _vm.detail.funnel,
      "buttons": _vm.detail.buttons,
      "preview": _vm.detail.preview,
      "transcript-cohort-sizes": _vm.cohortSizes,
      "from": _vm.trendFrom,
      "to": _vm.trendTo
    },
    on: {
      "back": _vm.closeDetail,
      "refresh": _vm.fetchDetail,
      "range-change": _vm.onRangeChange,
      "export": _vm.exportResponses,
      "cohort-sizes": _vm.loadCohortSizes,
      "export-transcripts": _vm.exportTranscripts
    }
  }) : (!_vm.campaignId) ? [_c('div', {
    staticClass: "na-tiles"
  }, [_c('div', {
    staticClass: "nc-surface na-tile"
  }, [_c('div', {
    staticClass: "na-tile-label"
  }, [_vm._v("Nudges delivered")]), _vm._v(" "), _c('div', {
    staticClass: "na-tile-value"
  }, [_vm._v(_vm._s(_vm.totals.delivered.toLocaleString()))]), _vm._v(" "), _c('div', {
    staticClass: "na-tile-sub"
  }, [_vm._v(_vm._s(_vm.campaigns.length) + " campaign" + _vm._s(_vm.campaigns.length === 1 ? '' : 's') + " in range")])]), _vm._v(" "), _c('div', {
    staticClass: "nc-surface na-tile"
  }, [_c('div', {
    staticClass: "na-tile-label"
  }, [_vm._v("Delivery rate")]), _vm._v(" "), _c('div', {
    staticClass: "na-tile-value"
  }, [_vm._v(_vm._s(_vm.totals.deliveryRate) + "%")]), _vm._v(" "), _c('div', {
    staticClass: "na-tile-sub"
  }, [_vm._v(_vm._s(_vm.totals.failed.toLocaleString()) + " failed of " + _vm._s(_vm.totals.attempts.toLocaleString()) + " attempts")])]), _vm._v(" "), _c('div', {
    staticClass: "nc-surface na-tile"
  }, [_c('div', {
    staticClass: "na-tile-label"
  }, [_vm._v("Users nudged")]), _vm._v(" "), _c('div', {
    staticClass: "na-tile-value"
  }, [_vm._v(_vm._s(_vm.totals.uniqueUsers.toLocaleString()))]), _vm._v(" "), _c('div', {
    staticClass: "na-tile-sub"
  }, [_vm._v("Distinct accounts")])]), _vm._v(" "), _c('div', {
    staticClass: "nc-surface na-tile"
  }, [_c('div', {
    staticClass: "na-tile-label"
  }, [_vm._v("Responses")]), _vm._v(" "), _c('div', {
    staticClass: "na-tile-value"
  }, [_vm._v(_vm._s(_vm.totals.responded.toLocaleString()))]), _vm._v(" "), _c('div', {
    staticClass: "na-tile-sub"
  }, [_vm._v("Nudges that got a reply")])]), _vm._v(" "), _c('div', {
    staticClass: "nc-surface na-tile"
  }, [_c('div', {
    staticClass: "na-tile-label"
  }, [_vm._v("Response rate")]), _vm._v(" "), _c('div', {
    staticClass: "na-tile-value"
  }, [_vm._v(_vm._s(_vm.totals.responseRate) + "%")]), _vm._v(" "), _c('div', {
    staticClass: "na-tile-sub"
  }, [_vm._v("Nudges replied to ÷ nudges delivered")])])]), _vm._v(" "), _c('div', {
    staticClass: "nc-surface nc-filters"
  }, [_c('div', {
    staticClass: "nc-field nc-field-grow"
  }, [_c('label', {
    attrs: {
      "for": "na-search"
    }
  }, [_vm._v("Search")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchText),
      expression: "searchText"
    }],
    staticClass: "nc-input",
    attrs: {
      "id": "na-search",
      "type": "text",
      "placeholder": "Campaign name — press Enter"
    },
    domProps: {
      "value": (_vm.searchText)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.reload.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchText = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "nc-field"
  }, [_c('label', {
    attrs: {
      "for": "na-from"
    }
  }, [_vm._v("From")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fromDt),
      expression: "fromDt"
    }],
    staticClass: "nc-input",
    attrs: {
      "id": "na-from",
      "type": "date"
    },
    domProps: {
      "value": (_vm.fromDt)
    },
    on: {
      "change": _vm.reload,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fromDt = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "nc-field"
  }, [_c('label', {
    attrs: {
      "for": "na-to"
    }
  }, [_vm._v("To")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.toDt),
      expression: "toDt"
    }],
    staticClass: "nc-input",
    attrs: {
      "id": "na-to",
      "type": "date"
    },
    domProps: {
      "value": (_vm.toDt)
    },
    on: {
      "change": _vm.reload,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.toDt = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "nc-field"
  }, [_c('label', {
    attrs: {
      "for": "na-scope"
    }
  }, [_vm._v("Campaigns")]), _vm._v(" "), _c('nv-select', {
    staticClass: "nc-input",
    attrs: {
      "id": "na-scope"
    },
    on: {
      "change": _vm.reload
    },
    model: {
      value: (_vm.scope),
      callback: function($$v) {
        _vm.scope = $$v
      },
      expression: "scope"
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("All campaigns")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "nudge-console"
    }
  }, [_vm._v("Nudge Console only")])])], 1)]), _vm._v(" "), (_vm.truncated) ? _c('div', {
    staticClass: "nc-notice nc-notice-warn"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" "), _c('span', [_vm._v("\n        More than " + _vm._s(_vm.limit) + " campaigns sent nudges in this range, so the totals above cover only\n        the " + _vm._s(_vm.limit) + " with the most delivered. Narrow the date range or search by name for exact\n        numbers.\n      ")])]) : _vm._e(), _vm._v(" "), (!_vm.loading && !_vm.campaigns.length) ? _c('div', {
    staticClass: "nc-surface nc-empty"
  }, [_c('div', {
    staticClass: "nc-empty-icon"
  }, [_c('i', {
    staticClass: "fa fa-line-chart"
  })]), _vm._v(" "), _c('div', {
    staticClass: "nc-empty-title"
  }, [_vm._v("No nudges were sent in this range")]), _vm._v(" "), _c('div', {
    staticClass: "nc-empty-text"
  }, [_vm._v("\n        Only campaigns that actually sent something appear here. Widen the date range, or clear\n        the filters.\n      ")])]) : _c('div', {
    staticClass: "nc-surface na-table-wrap"
  }, [_c('table', {
    staticClass: "na-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Campaign")]), _vm._v(" "), _c('th', [_vm._v("Window")]), _vm._v(" "), _c('th', {
    staticClass: "na-num"
  }, [_vm._v("Users")]), _vm._v(" "), _c('th', {
    staticClass: "na-num"
  }, [_vm._v("Sent")]), _vm._v(" "), _c('th', {
    staticClass: "na-num"
  }, [_vm._v("Delivered")]), _vm._v(" "), _c('th', {
    staticClass: "na-num"
  }, [_vm._v("Failed")]), _vm._v(" "), _c('th', {
    staticClass: "na-num"
  }, [_vm._v("Responses")]), _vm._v(" "), _c('th', {
    staticClass: "na-num"
  }, [_vm._v("Response rate")]), _vm._v(" "), _c('th', {
    staticClass: "na-col-actions"
  }, [_c('span', {
    staticClass: "na-sr-only"
  }, [_vm._v("Actions")])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.campaigns), function(row) {
    return [_c('tr', {
      key: row.id
    }, [_c('td', [_c('button', {
      staticClass: "na-row-toggle",
      attrs: {
        "aria-expanded": _vm.expanded[row.id] ? 'true' : 'false'
      },
      on: {
        "click": function($event) {
          return _vm.toggleRow(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-caret-right na-caret",
      class: {
        'is-open': _vm.expanded[row.id]
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "na-row-name"
    }, [_vm._v(_vm._s(row.opportunity_name))])]), _vm._v(" "), _c('div', {
      staticClass: "na-row-meta"
    }, [_vm._v("\n                  " + _vm._s(row.country_name || '—') + " · " + _vm._s(row.customer_name || 'No customer') + "\n                ")])]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(_vm.windowText(row)) + "\n                "), _c('div', {
      staticClass: "na-row-meta na-row-meta-flush"
    }, [_vm._v(_vm._s(_vm.groupsText(row)))])]), _vm._v(" "), _c('td', {
      staticClass: "na-num"
    }, [_vm._v(_vm._s(row.unique_users.toLocaleString()))]), _vm._v(" "), _c('td', {
      staticClass: "na-num"
    }, [_vm._v(_vm._s(row.attempts.toLocaleString()))]), _vm._v(" "), _c('td', {
      staticClass: "na-num"
    }, [_vm._v(_vm._s(row.delivered.toLocaleString()))]), _vm._v(" "), _c('td', {
      staticClass: "na-num"
    }, [_c('span', {
      class: row.failed ? 'na-failed' : ''
    }, [_vm._v(_vm._s(row.failed.toLocaleString()))])]), _vm._v(" "), _c('td', {
      staticClass: "na-num"
    }, [_vm._v(_vm._s(row.responded.toLocaleString()))]), _vm._v(" "), _c('td', {
      staticClass: "na-num"
    }, [_c('span', {
      staticClass: "na-rate"
    }, [_vm._v("\n                  " + _vm._s(_vm.responseRateOf(row)) + "%\n                  "), _c('span', {
      staticClass: "na-rate-bar"
    }, [_c('span', {
      staticClass: "na-rate-bar-fill",
      style: ({
        width: Math.min(_vm.responseRateOf(row), 100) + '%'
      })
    })])])]), _vm._v(" "), _c('td', {
      staticClass: "na-col-actions"
    }, [_c('router-link', {
      staticClass: "nc-btn nc-btn-sm nc-btn-quiet na-detail-link",
      attrs: {
        "title": "Open the full campaign view",
        "to": {
          path: '/nudge-console/analytics',
          query: {
            campaignId: row.id
          }
        }
      }
    }, [_vm._v("\n                  Details "), _c('i', {
      staticClass: "fa fa-angle-right"
    })])], 1)]), _vm._v(" "), _vm._l(((_vm.expanded[row.id] ? row.group_list : [])), function(group) {
      return _c('tr', {
        key: ((row.id) + "-" + (group.group_id)),
        staticClass: "na-group-row"
      }, [_c('td', {
        staticClass: "na-group-name"
      }, [_c('span', {
        staticClass: "na-group-label"
      }, [_vm._v(_vm._s(group.group_name || 'Unnamed group'))]), _vm._v(" "), (group.split_percent) ? _c('span', {
        staticClass: "na-group-split"
      }, [_vm._v(_vm._s(group.split_percent) + "% of traffic")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(group.msg_template_name || 'Generated content'))]), _vm._v(" "), _c('td', {
        staticClass: "na-num"
      }, [_vm._v(_vm._s(group.unique_users.toLocaleString()))]), _vm._v(" "), _c('td', {
        staticClass: "na-num"
      }, [_vm._v(_vm._s(group.attempts.toLocaleString()))]), _vm._v(" "), _c('td', {
        staticClass: "na-num"
      }, [_vm._v(_vm._s(group.delivered.toLocaleString()))]), _vm._v(" "), _c('td', {
        staticClass: "na-num"
      }, [_vm._v(_vm._s(group.failed.toLocaleString()))]), _vm._v(" "), _c('td', {
        staticClass: "na-num"
      }, [_vm._v(_vm._s(group.responded.toLocaleString()))]), _vm._v(" "), _c('td', {
        staticClass: "na-num"
      }, [_vm._v(_vm._s(_vm.responseRateOf(group)) + "%")]), _vm._v(" "), _c('td', {
        staticClass: "na-col-actions"
      })])
    })]
  })], 2)]), _vm._v(" "), _c('p', {
    staticClass: "na-table-note"
  }, [_vm._v("\n        Sent, delivered, failed and responses count individual nudges, so response rate is\n        nudges replied to ÷ nudges delivered. Users counts distinct accounts.\n        "), (_vm.hasSharedVariantUsers) ? [_vm._v("\n          On a campaign that re-fires the A/B split is applied per send, so one account can\n          receive both variants — variant Users counts can add up to more than the\n          campaign's. The message columns still add up exactly.\n        ")] : _vm._e()], 2)])] : _vm._e()], 2), _vm._v(" "), (_vm.loading) ? _c('BlockUI', [_c('i', {
    staticClass: "fa fa-cog fa-spin fa-3x fa-fw"
  }), _c('br'), _vm._v("Please wait...")]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("Nudge Console")]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" Home")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Analytics")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-78478226","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/nudge-console/NudgeAnalytics.vue
// module id = gi6t
// module chunks = 1